import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FloatMessageService } from './float-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StatusCodeEnum } from '../general/status-code.enum';
import { MaintenanceService } from './maintenance.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(private floatMessage: FloatMessageService, private spinnerService: NgxSpinnerService,
    private maintenanceService:MaintenanceService,private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.addToken(request, sessionStorage.getItem('id_token')))
      .pipe(catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status == 500) {
            this.floatMessage.showNotification("error", "Something went wrong. Please contact administrator.");
          }
          //Handle Gateway Timeout or server down
          if(err.status ==StatusCodeEnum.ServiceUnavailable){
           //Set session variable once down
           sessionStorage.setItem("isServerUnavailable","true");
           //Redirect to landing page
           this.router.navigate(['']);
          }
          if(err.status ==StatusCodeEnum.GatewayTimeOut){
           //Set session variable once down
            sessionStorage.setItem("isServerUnavailable","true");
            this.router.navigate(['']);
          }
          if(err.status ==StatusCodeEnum.BadGateway){
            //Set session variable once down
             sessionStorage.setItem("isServerUnavailable","true");
             this.router.navigate(['']);
           }
          this.spinnerService.hide();
        }
        return throwError(err);
      }));
  }
  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    //let isRefreshToken = req.params.get('isRefreshToken')
    if(req.url.includes(environment.creditorAPIEndpoint))
    req = req.clone({ setHeaders: { 'Ocp-Apim-Subscription-Key':  environment.apimSubscriptionKey} });
    if(token){
      return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } })
    }
    return req;
  }
}
